import { z } from "zod";

export const ProblemSchema = z
  .object({
    type: z.string(),
    title: z.string(),
    status: z.number().int(),
    detail: z.string().optional(),
    code: z.string().optional(),
    instance: z.string().optional(),
    requestId: z.string().optional(),
    traceId: z.string().optional(),
    errors: z
      .array(
        z.object({
          path: z.array(z.union([z.string(), z.number()])),
          message: z.string(),
        }),
      )
      .optional(),
  })
  .strict();

export type Problem = z.infer<typeof ProblemSchema>;
